import { render } from "./ModalSurveyQuestion.vue?vue&type=template&id=019660cc"
import script from "./ModalSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./ModalSurveyQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__